export enum EStatEventType {
	PURCHASE_OFFER = 'Purchase_offer',
	PURCHASE_PHONE = 'Purchase_phone',
	PURCHASE_SMS = 'Purchase_sms',
	PURCHASE_CANCEL = 'Purchase_cancel',
	SUBSCRIBE_SUCCESS = 'Subscribe_success',

	BOOM_LANDING_OPEN = 'Boom_landing_open',

	BOOM_BRAND_OPEN = 'Boom_brand_open',
	BOOM_BRAND_DOWNLOAD = 'Boom_brand_download',
	BOOM_BRAND_DOWNLOAD_ALL = 'Boom_brand_download_all',

	BOOM_DMCA_OPEN = 'boom_dmca_open',
	BOOM_DMCA_SUBMIT = 'boom_dmca_submit',
	BOOM_DMCA_SUCCESS = 'boom_dmca_success',
	BOOM_DMCA_ERROR = 'boom_dmca_error',
	BOOM_DMCA_UPLOAD_FILE = 'boom_dmca_upload_file',
	BOOM_DMCA_UPLOAD_FILE_SUCCESS = 'boom_dmca_upload_file_success',
	BOOM_DMCA_UPLOAD_FILE_CANCELLED = 'boom_dmca_upload_file_cancelled',
	BOOM_DMCA_UPLOAD_FILE_ERROR = 'boom_dmca_upload_file_error',
	BOOM_DMCA_UPLOAD_FILE_CHUNK_ERROR = 'boom_dmca_upload_file_chunk_error',

	SHARING_ALBUM_OPEN = 'Sharing_album_open',
	SHARING_ARTIST_OPEN = 'Sharing_artist_open',
	SHARING_PLAYLIST_OPEN = 'Sharing_playlist_open',
	SHARING_TRACK_OPEN = 'Sharing_track_open',
	SHARING_USER_OPEN = 'Sharing_user_open',
	SHARING_ERROR_OPEN = 'Sharing_error_open',
	SHARING_PLAY = 'Sharing_play',

	OPEN_STORE = 'Open_store',

	UPLOAD_FILE = 'upload_file',
	UPLOAD_FILE_SUCCESS = 'upload_file_success',
	UPLOAD_FILE_CANCELLED = 'upload_file_cancelled',
	UPLOAD_FILE_ERROR = 'upload_file_error',
	UPLOAD_FILE_CHUNK_ERROR = 'upload_file_chunk_error',

	WEBVIEW_COMBO_LINK = 'webview_combo_link',
}
